<template>
  <div class="bindcard-page">
    <!-- 顶部导航 -->
    <header class="header">
      <div class="header-back" @click="back()">
        <van-icon name="arrow-left" />
      </div>
      <h1 class="header-title">{{ $t('my.my_bank_card') || '新增金融卡' }}</h1>
      <div class="header-placeholder"></div>
    </header>

    <!-- 表单内容 -->
    <div class="form-container">
      <!-- 開戶銀行 -->
      <div class="form-group">
        <label class="form-label">{{ $t('setting.band_name') || '開戶銀行' }}</label>
        <input v-model="formData.bank" type="text" class="form-input" :placeholder="$t('setting.band_name_tip') || '无卡'"
          />
      </div>

      <!-- 分行名稱 -->
      <div class="form-group">
        <label class="form-label">{{ $t('setting.branch_name') || '分行名稱' }}</label>
        <input v-model="formData.bankfenhang" type="text" class="form-input"
          :placeholder="$t('setting.branch_name_tip') || '无卡'" />
      </div>

      <!-- 開戶姓名 -->
      <div class="form-group">
        <label class="form-label">{{ $t('setting.kh_username') || '開戶姓名' }}</label>
        <input v-model="formData.username" type="text" class="form-input"
          :placeholder="$t('setting.username_place') || '请输入开户姓名'" />
      </div>

      <!-- 金融卡號 -->
      <div class="form-group">
        <label class="form-label">{{ $t('setting.band_account') || '金融卡號' }}</label>
        <input v-model="formData.bankid" type="text" class="form-input"
          :placeholder="$t('setting.band_account_tip') || '请输入卡号'" />
      </div>

      <!-- 警告信息 -->
      <div class="warning-text">
        {{ $t('setting.bank_warn') || '请输入绑定银行卡的正确信息' }}
      </div>

      <!-- 支持銀行 -->
      <div class="form-group">
        <label class="form-label">{{ $t('setting.support_bank') || '交易密碼' }}</label>
        <input v-model="formData.password" type="password" class="form-input"
          :placeholder="$t('setting.support_bank_place') || '請輸入您設置的交易密碼'" />
      </div>
      <!-- 提交按钮 -->
      <button class="submit-btn" @click="bindCard">
        {{ $t('setting.bank_ok') || '提交' }}
      </button>
    </div>

    <!-- 銀行選擇器 -->
    <van-popup v-model="showBank" round position="bottom" :style="{ height: '35%' }">
      <van-picker show-toolbar :columns="banks" @confirm="onConfirm" @cancel="onCancel" />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banks: [],
      showBank: false,
      userInfo: {},
      formData: {
        bank: '',
        bankfenhang: '',
        username: '',
        bankid: '',
        password: ''
      },
      bank_code: '',
      fhnumber: ''
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    bindCard() {
      // 验证表单
      if (!this.formData.bank || this.formData.bank === '') {
        this.$toast(this.$t('setting.band_name_tip') || '請選擇銀行');
        return false;
      }

      if (!this.formData.username || this.formData.username === '') {
        this.$toast(this.$t('setting.username_place') || '請輸入開戶姓名');
        return false;
      }

      if (!this.formData.bankfenhang || this.formData.bankfenhang === '') {
        this.$toast(this.$t('setting.branch_name_tip') || '請輸入分行名稱');
        return false;
      }

      if (!this.formData.bankid || this.formData.bankid === '') {
        this.$toast(this.$t('setting.band_account_tip') || '請輸入卡號');
        return false;
      }

      if (!this.formData.password || this.formData.password === '') {
        this.$toast(this.$t('setting.support_bank_place') || '請輸入交易密碼');
        return false;
      }

      this.$http({
        method: 'post',
        data: {
          bankid: this.formData.bankid,
          bank: this.formData.bank,
          bank_code: this.bank_code,
          username: this.formData.username,
          bankfenhang: this.formData.bankfenhang,
          fhnumber: this.fhnumber,
          password: this.formData.password
        },
        url: 'user_set_bank'
      }).then(res => {
        if (res.code === 200) {
          this.$toast(res.msg || 'Success');
          setTimeout(() => {
            this.$router.push({ path: '/Mine' });
          }, 1000);
        } else if (res.code === 401) {
          this.$toast(res.msg || 'Unauthorized');
          this.$router.push({ path: '/Login' });
        } else {
          this.$toast(res.msg || 'Failed to bind card');
        }
      })
    },
    showSelectBanks() {
      this.showBank = true;
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
          this.$router.push({ path: '/Login' });
        }
      });
    },
    getBankList() {
      this.$http({
        method: 'get',
        url: 'sys_get_banks'
      }).then(res => {
        if (res.code === 200) {
          this.banks = res.data || [];
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    onConfirm(value) {
      this.formData.bank = value.text;
      this.bank_code = value.value;
      this.showBank = false;
    },
    onCancel() {
      this.showBank = false;
    },
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.formData = {
              bank: res.data.info.bankinfo || '',
              bankfenhang: res.data.info.bankfenhang || '',
              username: res.data.info.username || '',
              bankid: res.data.info.bankid || ''
            };
            this.fhnumber = res.data.info.fhnumber || '';
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserInfo();
      this.getBankList();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang="less" scoped>
.bindcard-page {
  min-height: 100vh;
  background: #151515;
  color: #f5f5f5;
  padding-bottom: 80px;
}

/* 头部 */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #151515;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.header-back {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 28px;
  color: #fff;
}

.header-title {
  flex: 1;
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  color: #22cc61;
  margin: 0;
}

.header-placeholder {
  width: 40px;
}

/* 表单容器 */
.form-container {
  padding: 20px 16px;
}

.form-group {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
}

.form-label {
  font-size: 28px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 8px;
}

.form-input {
  padding: 12px 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  background: #fff;
  color: #000;
  font-size: 28px;
  outline: none;
  transition: all 0.3s;


  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
}

/* 警告信息 */
.warning-text {
  padding: 12px 16px;
  margin: 16px 0;
  background: rgba(255, 68, 68, 0.1);
  border-left: 3px solid #ff4444;
  color: #ff4444;
  font-size: 24px;
  border-radius: 4px;
}

/* 支持銀行按钮 */
.support-btn {
  padding: 12px 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.6);
  font-size: 28px;
  cursor: pointer;
  transition: all 0.3s;
  text-align: left;

  &:active {
    opacity: 0.8;
  }
}

/* 提交按钮 */
.submit-btn {
  width: 100%;
  padding: 14px 16px;
  margin-top: 30px;
  background: #22cc61;
  color: #000;
  border: none;
  border-radius: 6px;
  font-size: 28px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s;

  &:active {
    opacity: 0.9;
    transform: scale(0.98);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}
</style>
